module.exports = {
  NODE_ENV: 'production',
  // requestUrl: 'http://172.16.213.30:8082'
  requestUrl: 'http://218.201.243.209:8091'
  // requestUrl: 'http://192.168.1.213:8082'
}